import { store } from "../index";
import { set_socket_receive_data } from "../container/RouterDetail/routerDetail.slice";

export function team_lead_add_callback(values) {
  store.dispatch(set_socket_receive_data(values));
}
